/* eslint-disable react-refresh/only-export-components */
/* eslint-disable react/prop-types */
import {
  bookMarkSessionApi,
  createAudioSession,
  deleteSessionByIdApi,
  getAllSession,
} from "@/app/api";
import { handleResponseError } from "@/utils/errorHandler";
import { createContext, useContext, useState } from "react";
import { toast } from "@/utils/useToast";

// Create Context
const SessionContext = createContext();

// Context Provider
export const SessionProvider = ({ children }) => {
  const [sessions, setSessions] = useState([]);
  const [currentSession, setCurrentSession] = useState(null);
  const [loading, setLoading] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedSession, setSelectedSession] = useState(null);
  const [isBookmarked, setBookMarked] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const updateSessions = (newSessions) => {
    setSessions(newSessions);
  };
  const setCurrent = (summary) => {
    setCurrentSession(summary);
  };
  const getSessionById = (sessionId) => {
    return sessions[sessionId] || null;
  };

  const deleteSessionById = async (data) => {
    const { sessionId } = data;
    setLoading(true);
    setDeleteModalOpen(false);
    try {
      await deleteSessionByIdApi(sessionId);
      setLoading(false);

      toast.success("Success");
      listSessions();
    } catch (error) {
      setDeleteModalOpen(false);
      await handleResponseError(error);
      setLoading(false);
    }
  };
  const listSessions = async (page = 1, limit = 10) => {
    setLoading(true);
    try {
      const res = await getAllSession(page, limit);
      setSessions(res.data.sessions || res.data);
      setTotalPages(res.data.totalPages || 1);
      setTotalRecords(res.data.totalRecords || (res.data.sessions || res.data).length);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      await handleResponseError(error);
    }
  };

  const toggleBookMark = async (sessionId) => {
    setLoading(true);
    try {
      await bookMarkSessionApi(sessionId);
      setBookMarked((prev) => !prev);
    } catch (error) {
      setLoading(false);
      await handleResponseError(error);
    }
  };

  const initSession = async (data) => {
    setLoading(true);
    try {
      const res = await createAudioSession(data);
      if (!res.data.status) {
        setBookMarked(res.data.existingSession.bookMarked);
      }
      setLoading(false);
    } catch (error) {
      // if (error) {
      //   const sessionId = generateUUID();
      //   console.log({ error });
      //   navigate(`/dashboard/audio/record/${sessionId}`, {
      //     state: { language, date: timeStamp },
      //   });
      // }
      await handleResponseError(error);
    }
  };

  return (
    <SessionContext.Provider
      value={{
        initSession,
        loading,
        isBookmarked,
        toggleBookMark,
        deleteSessionById,
        sessions,
        currentSession,
        updateSessions,
        getSessionById,
        setCurrent,
        deleteModalOpen,
        setDeleteModalOpen,
        selectedSession,
        setSelectedSession,
        listSessions,
      }}
    >
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = () => useContext(SessionContext);
